import React, { useEffect, useState } from "react";

export default function FakeAnalyzeModal({
    images,
    onFinish = () => {},
}: {
    images: string[];
    onFinish?: () => void;
}) {
    const [previewImage, setPreviewImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setPreviewImage((counter) => {
                if (counter > images.length - 2) {
                    clearInterval(interval);
                    onFinish();
                    return counter;
                } else {
                    return counter + 1;
                }
            });
        }, 1000);
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "40px",
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                    maxWidth: "600px",
                    width: "90%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "25px",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        height: "20em",
                    }}
                >
                    {images.map((imgSrc, index) => (
                        <img
                            style={{
                                height: "100%",
                                display:
                                    previewImage === index ? "block" : "none",
                            }}
                            src={imgSrc}
                        ></img>
                    ))}
                </div>
                <h3
                    style={{
                        fontSize: "1.8em",
                        color: "#333",
                        marginBottom: "15px",
                        textAlign: "center",
                    }}
                >
                    Neue Trainingsbilder verarbeiten
                </h3>
                <div
                    style={{
                        width: "80%",
                        height: "10px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#4c84ff",
                            borderRadius: "5px",
                            animation: `loading-bar ${images.length}s forwards linear`,
                        }}
                    />
                </div>
                <style>
                    {`@keyframes loading-bar {
                        0% { width: 0%; }
                        100% { width: 100%; }
                    }`}
                </style>
            </div>
        </div>
    );
}
